import React from "react";
import ReflexLayout from "../components/ReflexLayout";
import ReflexNavigation from "../components/ReflexNavigation";
import ReflexCurrentMonth from "./ReflexCurrentMonth";
import useUsuario from "~fetchs/useUsuario";
import { useConfigureFooter } from "~hooks/useHelpers";

const Result = () => {
  const { usuario } = useUsuario();

  const isCrcSomenteReflex = usuario?.usuarioPerfils?.some(
    (usuarioPerfil) => usuarioPerfil?.perfil?.slug === "acesso-crc-somente-modulo-reflex"
  );

  useConfigureFooter(
    isCrcSomenteReflex
      ? { variation: "simpliest" }
      : { hideReturnButton: true }
  );

  return (
    <ReflexLayout>
      {globalThis.location.pathname !== `/reflex/historico` ? (
        <ReflexNavigation></ReflexNavigation>
      ) : (
        <>
          <ReflexCurrentMonth />
        </>
      )}
    </ReflexLayout>
  );
};

export default Result;
